import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ProductService } from 'app/services/product.service';
import { AlertsService } from 'app/ui-components/alerts/alerts.service';
import { states } from '../../utilities/states';
import { LineUpdate, Product, ProductDtls, ProductName, ProductNames, TierName, UpdateOrderRequest } from 'app/models/products.model';
import { formatCurrency } from 'app/utilities/format-utils';
import { UserService } from 'app/users/user.service';
import { SharedDataService } from 'app/services/sharedData.service';
import { timer } from 'rxjs/internal/observable/timer';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BillingAddress} from 'app/models/customer.model';
import { CustomerService } from 'app/services/customer.service';
import { environment } from 'environments/environment';
import { encrypt, decrypt } from  'app/utilities/url.utilities';
import { AuthService, Passport } from 'app/services/auth.service';
import * as uuid from 'uuid';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { PageConfig } from 'config/page.config';
import { OrderService } from 'app/services/order.service';
import { TrackingService, AbandonCartEvents, AbandonCartDataKeys as DataKeys, FlowResponse } from 'app/services/tracking.service';
import { switchMap, map, tap, catchError, filter } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-billing-page',
  templateUrl: './billing-page.component.html',
  styleUrls: ['./billing-page.component.css']
})
export class BillingPageComponent implements OnInit {
 
  abrStates = states;
  products : Product[] =[];  
  memberQty: [{[key: string]: number[]}] = [{}];
  nonmberQty: [{[key: string]: number[]}] = [{}];
  promoCodes: string[] = [];
  totalPrice: number = 0.00;
  totalDiscount: number = 0.00;
  prods: [{[key: string]: number}] = [{}];
  cartProds: [{[key: string]: ProductDtls}] = [{}]; 
  prodPrices: [{[key: string]: number}] = [{}];
  membership: string = TierName.NONMBR;
  promoCodeValue: string ='';
  errorMessage: string ='';
  loaded: boolean = false;
  storedProducts: any;
  billingAddress!: FormGroup
  orderNumber!: string;
  isSmallView: boolean = false;
  preApprovalUrl: string = environment.zendeskUrl;
  forRenewal: boolean = false;
  renewalProductsInCart: any;
  renewalQuantity!: number;
  productNumber!: string;
  flowId?: string;
  fromAbandonEmail: boolean = false;
  private _initialTrackingSaved = false;
  customerNumber!: string;
  isAdmin : boolean = false;
  isSubUserNotAdmin: boolean =  false;

  constructor(private router: Router,
    private productService: ProductService,
    private customerService: CustomerService,
    private userService: UserService,
    private sharedDataService: SharedDataService,
    private alertService: AlertsService,
    private authService: AuthService,
    private orderService: OrderService,
    private dialog: MatDialog,
	  private responsive: BreakpointObserver,
    private trackingService: TrackingService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.flowId = this.route.snapshot.queryParamMap.get('flowId') || '';
		this.customerNumber = this.userService.profile.customerNumber;
    this.determineViewMode();

        let token: Passport = {
          id: uuid.v4(),
          userFlow: 'billing',
          customerNumber: this.userService.profile.customerNumber
        };

        this.authService.getToken(token).pipe(

        // Step 1: wait for token
        switchMap(() => {
            if (this.flowId) {
              this.fromAbandonEmail = true;

              // Step 2: return observable for getFlowById
              return this.trackingService.getFlowById(this.flowId).pipe(
                map(flow => {
                  if (this.populateFormFromAbandonCartInfoInError(flow)) {
                      return of(false);
                  }
                  this.populateFormFromAbandonCartInfo(flow)
                  return true; // continue pipeline
                }),
                catchError(err => {
                  console.log(`Error loading flow: ${this.flowId} err ${err}`);
                  this.sharedDataService.removeFlowId();
                  this.router.navigate(['/']);
                  return of(false); 
                })
              );
            }

            // Step 3: if no flowId → continue without calling getFlowById
            return of(true);
          }),
          // 
          filter(result => result === true),
          // Step 4: after token + (optional) flow is done
          tap(() => {
            let prodNames: string[] = [];
            this.prods.pop();
            if (typeof this.sharedDataService.orderNumber !== "undefined" && this.sharedDataService.orderNumber.length > 0) {
              this.orderNumber = this.sharedDataService.orderNumber;
              var prods = sessionStorage.getItem("cartProducts");
              if(prods) { 
                  this.storedProducts = prods;
                  const savedProducts = JSON.parse(prods);                
                  for (var product of savedProducts) {
                    const key = Object.keys(product)[0];
                    this.prods.push({[key]: product[key].quantity});
                    prodNames.push(key);
                  }  
              }
            } else {
              this.storedProducts = sessionStorage.getItem("products")
              if ( this.storedProducts !== null) { this.prods = JSON.parse(this.storedProducts) };              
              for (var prod of this.prods) {
                prodNames.push(Object.keys(prod)[0]);
              }  
            }
            this.retrieveSubscription(prodNames);
          })
        )
         .subscribe();
  }

  loadPage(workflow:string) {
    if(!this.isSubUserNotAdmin) {
      this.membership = this.userService.isInGroup('member') ? TierName.MEMBER : TierName.NONMBR;
      if (this.storedProducts !== null) {
        this.sharedDataService.getProducts.subscribe(data => {
          if (data.length>0) {
            this.products = data;    
            this.loadData();
            this.loaded = true;        
          } else {
            this.productService.fetchProducts()
            .subscribe({
              next: (res) => {
                this.products = res.Data.results;
                this.sharedDataService.setProducts(this.products);
                this.loadData();              
                this.loaded = true;
              },
              error: (err) => { 
                console.log(err);
                this.alertService.displayError("Error getting products: " + err.message);
              }              
            });
          }
          this.saveInitialTrackingInfo(workflow);
        });      
      }
    }
  }

  loadData() {
    this.prodPrices.pop();
    for (var prod of this.prods) {
      const key = Object.keys(prod)[0];
      var mQty: number[] = [];
      var nmQty: number[] = [];
      this.nonmberQty.pop();
      this.memberQty.pop();
      const product = this.products.find( (p) => p.itemNumber = key);
      const nonMember = product?.tiers.find( t => t.tierName === TierName.NONMBR);
      nonMember?.tierDetails.forEach( t => nmQty.push(t.effectiveQuantity));
      const member = product?.tiers.find( t => t.tierName === TierName.MEMBER);
      member?.tierDetails.forEach( t => mQty.push(t.effectiveQuantity));
      this.nonmberQty.push({[key]: nmQty});
      this.memberQty.push({[key]: mQty});
      this.calculateProductPrice(key);
      this.retrieveAdditionalDetails();
    }   
    this.initializeForm();
  }

  initializeForm() {
    //pre-populate address if already saved
    let address = this.sharedDataService.userAddress;
    let company = this.sharedDataService.userCompany; //to avoid company field from being dropped
    this.billingAddress = new FormGroup({
      email: new FormControl(address? address.Address.Email : '', [Validators.required, Validators.email]),
      firstName: new FormControl(address? address.Address.Name.First : '', [Validators.required]),
      lastName: new FormControl(address? address.Address.Name.Last : '', [Validators.required]),
      company: new FormControl(company? company : '', []),
      addressLine1: new FormControl(address? address.Address.PostalAddress.Line1 : '', [Validators.required, Validators.minLength(6)]),
      addressLine2: new FormControl(address? address.Address.PostalAddress.Line2 : '', []),
      city: new FormControl(address? address.Address.PostalAddress.City : '', [Validators.required, Validators.minLength(3)]),
      state: new FormControl(address? address.Address.PostalAddress.StateCode : '', [Validators.required]),
      zipCode: new FormControl(address? address.Address.PostalAddress.PostalCode : '', [Validators.required, Validators.minLength(5)]),
      phone: new FormControl(address? address.Address.Phone : '', 
        [Validators.required,Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$"), Validators.minLength(10), Validators.maxLength(10)])    
    });
    
  }
  
  setTotalPrice() {
    for (var price of this.prodPrices) {
      const key = Object.keys(price)[0];
      this.totalPrice =+ price[key];  
    }    
  }

  getTotalPrice() {
    return formatCurrency(this.totalPrice);
  }

  getTotalDiscount() {
    return formatCurrency(this.totalDiscount);
  }

  isError() {
    return this.errorMessage.length > 0;
  }

  minus(itemNumber:string) {
    let rangeQty = 0;
    let rangePrice = 0.00;
    let prices = this.membership === TierName.MEMBER ? this.memberQty.find( q => q[itemNumber].length > 0) : this.nonmberQty.find( q => q[itemNumber].length > 0);
    let priceByQty: number[] = (typeof prices === 'undefined') ? [] : prices[itemNumber];    
    let quantity = this.getQuantity(itemNumber) - 1 < 0  ? 0 : this.getQuantity(itemNumber) -1;
    if (quantity !== 0) {
      for (let i = 0; i < priceByQty.length - 1; i++) {
        if (priceByQty[i] <= quantity && quantity < priceByQty[i+1]) {
          rangeQty = priceByQty[i]
          break;
        }
      }      
    } 
    const product = this.products.find( (p) => p.itemNumber = itemNumber);
    const tier = product?.tiers.find( t => t.tierName === this.membership);      
    if (quantity !== 0 && typeof tier !== 'undefined') {
      const price = tier.tierDetails.find(t => t.effectiveQuantity === rangeQty)?.unitPrice;  
      rangePrice = typeof price !== 'undefined' ? price : 0.00;
    } 
    if(quantity >= 0) {
      if(this.getTotalQuantity() > 0) {
        this.sharedDataService.setQuantity(this.getTotalQuantity()-1);
        this.setQuantity(itemNumber, quantity);
        this.updateCartProductQuantity(itemNumber, quantity);
      } 
      //may look redundant, but needed to prevent final emittance being lost - do not remove
      if(quantity === 0 && this.getTotalQuantity() === 0) {
        this.sharedDataService.setQuantity(this.getTotalQuantity()-1);
      }
    }
    const prodPrice = rangePrice * quantity;
    this.setProductTotalPrice(itemNumber, prodPrice);
    this.setTotalPrice();
  } 

  plus(itemNumber:string) {
    let rangeQty = 0;
    let rangePrice = 0.00;
    var quantity = this.getQuantity(itemNumber) + 1;
    let prices = this.membership === TierName.MEMBER ? this.memberQty.find( q => q[itemNumber].length > 0) : this.nonmberQty.find( q => q[itemNumber].length > 0);
    let priceByQty: number[] = (typeof prices === 'undefined') ? [] : prices[itemNumber];
    for (let i = 0; i < priceByQty.length - 1; i++) {
      if (priceByQty[i] <= quantity && quantity < priceByQty[i+1]) {
        rangeQty = priceByQty[i]
        break;
      }
    }
    const product = this.products.find( (p) => p.itemNumber = itemNumber);
    const tier = product?.tiers.find( t => t.tierName === this.membership);
    const price = tier?.tierDetails.find(t => t.effectiveQuantity === rangeQty)?.unitPrice;
    rangePrice = typeof price !== 'undefined' ? price : 0.00;
    this.sharedDataService.setQuantity(this.getTotalQuantity()+1);
    this.updateCartProductQuantity(itemNumber, quantity);
    this.setQuantity(itemNumber, quantity);
    const prodPrice = rangePrice * quantity;
    this.setProductTotalPrice(itemNumber, prodPrice);
    this.setTotalPrice();
  } 

  calculateProductPrice(itemNumber:string) {
    let rangeQty = 0;
    let rangePrice = 0.00;
    var quantity = this.getQuantity(itemNumber);
    let prices = this.membership === TierName.MEMBER ? this.memberQty.find( q => q[itemNumber].length > 0) : this.nonmberQty.find( q => q[itemNumber].length > 0);
    let priceByQty: number[] = (typeof prices === 'undefined') ? [] : prices[itemNumber];
    for (let i = 0; i < priceByQty.length - 1; i++) {
      if (priceByQty[i] <= quantity && quantity < priceByQty[i+1]) {
        rangeQty = priceByQty[i]
        break;
      }
    }
    const product = this.products.find( (p) => p.itemNumber = itemNumber);
    const tier = product?.tiers.find( t => t.tierName === this.membership);
    const price = tier?.tierDetails.find(t => t.effectiveQuantity === rangeQty)?.unitPrice;
    rangePrice = typeof price !== 'undefined' ? price : 0.00;
    this.setQuantity(itemNumber, quantity);
    const prodPrice = rangePrice * quantity;
    this.setProductTotalPrice(itemNumber, prodPrice);
    this.setTotalPrice();
  } 

  getTerm(itemNumber: string) {
    const product = this.products.find( (p) => p.itemNumber = itemNumber);
    const tier = product?.tiers.find( t => t.tierName === this.membership);
    const term = tier?.tierDetails[0].servicePeriodCode.substring(2).replace(/0/gi,'');
    
    return "Term: " + term + ((term === '1') ? " Year": " Years");
  }

  getUnitPrice(itemNumber: string) {
    let rangeQty = 0;
    let rangePrice = 0.00;
    var quantity = this.getQuantity(itemNumber);
    let prices = this.membership === TierName.MEMBER ? this.memberQty.find( q => q[itemNumber].length > 0) : this.nonmberQty.find( q => q[itemNumber].length > 0);
    let priceByQty: number[] = (typeof prices === 'undefined') ? [] : prices[itemNumber];
    for (let i = 0; i < priceByQty.length - 1; i++) {
      if (priceByQty[i] <= quantity && quantity < priceByQty[i+1]) {
        rangeQty = priceByQty[i]
        break;
      }
    }
    const product = this.products.find( (p) => p.itemNumber = itemNumber);
    const tier = product?.tiers.find( t => t.tierName === this.membership);
    const price = tier?.tierDetails.find(t => t.effectiveQuantity === rangeQty)?.unitPrice;
    rangePrice = typeof price !== 'undefined' ? price : 0.00;
    return formatCurrency(rangePrice);
  }

  setProductTotalPrice(itemNumber: string, total: number) {
    let found: boolean = false;
    for( var prod of this.prodPrices)
    {
      if (prod[itemNumber] !== null) {
        prod[itemNumber] = total;
        found = true;
      }
    }  
    if (!found) this.prodPrices.push({[itemNumber]: total});

  }

  getQuantity (itemNumber: string) {
    var quantity = 0;
    for (var product of this.prods) {
      if (product[itemNumber] !== null) {
        quantity = product[itemNumber];
      } 
    }
    return quantity;
  }

  setQuantity (itemNumber: string, quantity: number) {
    if(!this.isSubUserNotAdmin) {
      for (var product of this.prods) {
        if (product[itemNumber] !== null) {
          product[itemNumber] = quantity;
          sessionStorage.setItem('products', JSON.stringify(this.prods));
        } 
      }
    }
    return quantity;
  }  

  signup() {
    this.saveAppliedPromoCodes();
    sessionStorage.setItem("dicount", encrypt(JSON.stringify(this.totalDiscount)));
    window.location.href = environment.amaMembership;    
  }

  openDialog(templateRef: TemplateRef<any>) {
    if (this.membership === TierName.NONMBR) {
      this.dialog.open(templateRef);
    } else {
      this.gotoOrderReview();
    }  
  }

  gotoOrderReview() {
    let address: BillingAddress =
    {
        "CustomerNumber": this.userService.profile.customerNumber,
        "Address" : {
            "AddressCode" : "WBILL",
            "Name" : {
                "First" : (this.billingAddress.get("firstName")?.value + ""),
                "Last" :  (this.billingAddress.get("lastName")?.value + ""),
            },  
            "Company" : (this.billingAddress.get("company")?.value + ""),
            "Phone" : (this.billingAddress.get("phone")?.value + ""),
            "Email" : (this.billingAddress.get("email")?.value + ""),
            "PostalAddress" : {
              "City" :  (this.billingAddress.get("city")?.value + ""),
              "Line1" :  (this.billingAddress.get("addressLine1")?.value + ""),
              "Line2" :  (this.billingAddress.get("addressLine2")?.value + ""), 
              "PostalCode" :  (this.billingAddress.get("zipCode")?.value + ""),
              "StateCode" :  (this.billingAddress.get("state")?.value + "")
          }
      }
    };     
    let addrObj: Partial<BillingAddress> = {}; 
    Object.assign(addrObj, address);
    this.sharedDataService.setUserAddress(addrObj);
    if(addrObj.Address?.Company) {
      //setting company name specifically to prevent from being dropped from the address object occasionally
      this.sharedDataService.setUserCompany(addrObj.Address?.Company);
    }
    this.customerService.standardizeAddress(address).subscribe({
      next: response => {          
          if (response.Data === null) {
            this.alertService.displayError(response.ErrorMessage);
          } else {              
          if (response.Data.WasSuccessful) {
            address.Address.Company = response.Data.Company;
            address.Address.PostalAddress.Line1 = response.Data.Street1;
            address.Address.PostalAddress.Line2 = response.Data.Street2;
            address.Address.PostalAddress.City = response.Data.City;
            address.Address.PostalAddress.StateCode = response.Data.StateCode;
            address.Address.PostalAddress.PostalCode = response.Data.PostalCode;
            
          } else {
            address.AddressStandardizationSetting = "MarkForReview";
          }
          this.customerService.saveBillingAddress(address).
          subscribe({
            next: res => {
              if (res.ErrorMessage) {
                this.alertService.displayError(res.ErrorMessage);
              } else {  
                //this.alertService.displaySuccess("Customer Address was saved.");
                this.router.navigate(["/review"]);
              }
            },
            error: error => {
              this.alertService.displayError("Can not proceed with checkout: " + error.ErrorMessage);
            }  
          });   
        }
      },                  
      error: err => {
        this.alertService.displayError(err.message);
      }
    });
  }

  cleanUpLater() {
    timer(5000).subscribe(() => {
      this.errorMessage = '';
    });    
  }
  getAccessPeriod(itemNumber: string, quantity: number) {
    let rangeQty = 0;
    let prices = this.membership === TierName.MEMBER ? this.memberQty.find( q => q[itemNumber].length > 0) : this.nonmberQty.find( q => q[itemNumber].length > 0);
    let priceByQty: number[] = (typeof prices === 'undefined') ? [] : prices[itemNumber];
    for (let i = 0; i < priceByQty.length - 1; i++) {
      if (priceByQty[i] <= quantity && quantity < priceByQty[i+1]) {
        rangeQty = priceByQty[i]
        break;
      }
    }    
    const product = this.products.find( (p) => p.itemNumber = itemNumber);
    const tier = product?.tiers.find( t => t.tierName === this.membership);
    const accessCode = tier?.tierDetails.find(t => t.effectiveQuantity === rangeQty)?.servicePeriodCode;

    return accessCode;
  }

  applyPromoCode(promoCode: string) {
    if (promoCode.trim().length === 0 ) {
      this.errorMessage = 'Please enter valid promotion code.'
      this.cleanUpLater();
      return;
    }
    promoCode = promoCode.toUpperCase();
    let used: boolean = false;
    if (this.promoCodes && this.promoCodes.length > 0 ) {
        const found = this.promoCodes.find( (code) => code === promoCode );
        used = (typeof found !== 'undefined');
    }
    if (used) {
      this.alertService.displayError('The promotion code you entered was already used.');
      this.errorMessage = 'The promotion code you entered was already used.'
      this.cleanUpLater();
    } else {
      let lines: [any] = [{}];
      lines.pop();
      for (var prod of this.prods) {
        let key = Object.keys(prod)[0];
        let accessPeriod = this.getAccessPeriod(key, prod[key]);
        lines.push({
          "ItemNumber": key,
          "Quantity": prod[key],
            "PriceCode": this.membership,
            "AccessPeriod": accessPeriod          
        });

      }  
      this.productService.
      validatePromoCode(this.userService.profile.customerNumber, promoCode, lines).
      subscribe(res => {
        if (res.Errors.length > 0) {
          this.alertService.displayError(res.ErrorMessage);
        } else {     
          let valid = false;
          for (var prod of res.Data) { 
            if (prod.PromotionCodeValid === 'T') {
              valid = true;
              this.totalDiscount = this.totalDiscount + prod.DiscountAmount;
              this.totalPrice = this.totalPrice - prod.DiscountAmount;
              this.promoCodes.push(promoCode);
              this.saveAppliedPromoCodes();
              this.promoCodeValue = '';
              this.alertService.displaySuccess('The provided Promo Code was successfully applied');
            }  
          } 
          if (!valid) {
            this.errorMessage = 'The promotion code is invalid. Please try another code or call the Unified Service Center at (800) 621-8335 for assistance.'
            this.cleanUpLater();
            //this.alertService.displayError('The promotion code is invalid. Please try another code or call the Unified Service Center at (800) 621-8335 for assistance.');    
          }          
        }  
      })
    }  
  }

  getTotalQuantity(): number {
    var quantity = 0;
    for (var product of this.prods) {
        quantity = quantity + Number(Object.values(product));
    }
    return quantity;
  }

  retrieveAdditionalDetails(): void {
    var cartProducts = sessionStorage.getItem("cartProducts");
    if (sessionStorage.getItem("dicount") != null) {
      this.totalDiscount = +decrypt(sessionStorage.getItem("dicount")+"");
    }
    if (this.totalDiscount > 0) {
      this.totalPrice = this.totalPrice - this.totalDiscount;
    } 
    if (typeof this.sharedDataService.promoCodes !== "undefined") {
      this.promoCodes = this.sharedDataService.promoCodes;
    } 
    if (typeof this.sharedDataService.orderNumber !== "undefined" && this.sharedDataService.orderNumber.length > 0) {
      this.orderNumber = this.sharedDataService.orderNumber;
    } 
    if (cartProducts !== null) {
      this.cartProds = JSON.parse(cartProducts);   
      this.cartProds.forEach(prod => {
        const itemNumber = Object.keys(prod)[0];
        const product = this.products.find( (p) => p.itemNumber = itemNumber);
        const tier = product?.tiers.find( t => t.tierName === this.membership);
        const term = tier?.tierDetails[0].servicePeriodCode;
        prod[itemNumber].servicePeriodCode = term? term : '';
        prod[itemNumber].prodName = ProductName[itemNumber];
      });
      this.sharedDataService.setCartProducts(this.cartProds, false);
    } 
  }

  updateCartProductQuantity(itemNumber: string, quantity: number) : void {
    let needUpdate = false;
    for (var prod of this.cartProds) {
      if (prod[itemNumber] !== null) {
        prod[itemNumber].quantity = quantity;
        needUpdate = true;
      } 
    }
    if(needUpdate) {
      this.sharedDataService.setCartProducts(this.cartProds, false);
    }
  }

  saveAppliedPromoCodes(): void {
    if(this.promoCodes && this.promoCodes.length > 0) {
      this.sharedDataService.setPromoCodes(this.promoCodes, false);
      if(this.sharedDataService.orderNumber){ //order exists, so add it for the update call
        this.sharedDataService.setPromoCodeForUpdate(this.promoCodes[0], false);
      }
    }
  }

  determineViewMode() {
    this.responsive.observe([
          Breakpoints.TabletPortrait, Breakpoints.TabletLandscape,
          Breakpoints.HandsetLandscape, Breakpoints.HandsetPortrait])
          .subscribe(result => {
            const breakpoints = result.breakpoints;
            this.isSmallView = false;
            if (breakpoints[Breakpoints.TabletPortrait] || breakpoints[Breakpoints.TabletLandscape]
              || breakpoints[Breakpoints.HandsetPortrait] || breakpoints[Breakpoints.HandsetLandscape]) {
              this.isSmallView = true;
            } 
          }
        );
  }

  removePromoCode() {
    if (this.orderNumber) {
      const year = new Date().getFullYear().toString();
      const defaultPromoCode = 'W0' + year.substring(2);
      this.sharedDataService.setPromoCodeForUpdate(defaultPromoCode, false);
    } else {
      this.alertService.displaySuccess("Promo code has been removed");
    }
    this.promoCodes = [];
    this.sharedDataService.setPromoCodes([], true);
  }
  
  parseErrorMessage(msg: string): string {
    return msg.substring(msg.lastIndexOf(`,\"Message\":\"`)+12, msg.lastIndexOf(`\",\"WorkerId\"`));
  }

  getRenewalStartDate(itemNumber: string) {
    var prods = !this.renewalProductsInCart ? JSON.parse(this.storedProducts) : this.renewalProductsInCart; //fix undefined check 
    for (var product of prods) {
      if (product[itemNumber] != null) {
        return product[itemNumber].renewalStartDate;
      } 
    }
    return '';
  }

  retrieveSubscription(prodNames: string[]) {
      this.sharedDataService.getSubscriptions.subscribe(data => {
      if (data !== null) {
        this.prepareForRenewal(data);
      } else {
        this.customerService.fetchSubscriptions(this.userService.profile.customerNumber, (prodNames.length === 0) ? ProductNames : prodNames).subscribe({
              next: (res) => {
                if (res.Errors.length > 0 && res.Data === null) {
                  this.loadPage('purchase');
                } else {
                  if (res.Data.length > 1) {
                    this.router.navigate([PageConfig.paths.invalidPermissions, {error: 'Multiple active subscriptions.'}]);
                  } else {  
                    //check if user has access to renew first??
                    this.checkRenewalAccess(res.Data);
                    this.sharedDataService.setSubscriptions(res.Data);
                    if(this.isAdmin) {
                      this.prepareForRenewal(res.Data);
                    } else {
                      this.isSubUserNotAdmin = true;
                      this.sharedDataService.setCartProducts([{}], true);
                      this.sharedDataService.setQuantity(0);
                      sessionStorage.removeItem('products');
                      this.router.navigate(['/product', this.productNumber]);
                    }
                  }
                }
              },error: (err) => { 
                  console.log(err); 
                  this.loadPage('purchase');
              }   
        });
      }
    });
  }

  checkRenewalAccess(data : any) {
    const activeSubs = data.filter( (d) => d.Status.Name === "Active" );
    if(activeSubs) {  
      const subscription = activeSubs[0];
      this.productNumber  = subscription.Components[0].ItemNumber;
      const admins =  subscription.Participants.filter( (p) => p.CustomerNumber === this.customerNumber && p.AccessType.startsWith("Admin"))
      this.isAdmin = admins.length > 0;
    }
  }

  prepareForRenewal(data: any) {
    this.forRenewal = true;
    this.prepareProductForRenewal(data);
    var prods = sessionStorage.getItem("cartProducts");
    if(prods) { 
      this.storedProducts = JSON.parse(prods); 
      this.renewalProductsInCart = JSON.parse(prods);
      if(this.prods) {  
        for (var product of this.storedProducts) { 
          const key = Object.keys(product)[0];
          const index = this.prods.findIndex((p)=> Object.keys(p)[0] === key);
          if(index !== -1) {  
            this.prods.splice(index, 1, {[key]: product[key].quantity})
          } else {
            this.prods.push({[key]: product[key].quantity});
          }
        }
      } 
    }
    this.loadPage('renew');
  }

  prepareProductForRenewal(data : any) {
    const activeSubs = data.filter( (d) => d.Status.Name === "Active" );
    if(activeSubs) {
      const subscription = activeSubs[0];
      const productId = subscription.Components[0].ItemNumber;
      this.productNumber = productId;
      const quantity = this.getOrderReviewQuantityIfExists(subscription.Components[0].QuantityOrdered);
      this.sharedDataService.setQuantity(quantity);
      const servicePeriodCode = subscription.ServicePeriod.Code ?? '' ;
      const currentSubStartDate = new Date(subscription.TermStarts).toLocaleDateString();
      const currentSubExpDate = new Date(subscription.AgreementExpires).toLocaleDateString();
      let newSubDate = new Date(subscription.AgreementExpires);
      newSubDate.setDate(newSubDate.getDate() + 1);
      const renewalStartDate = new Date(newSubDate).toLocaleDateString();
      const agreementId = subscription.AgreementId;
      let cartProducts = sessionStorage.getItem('cartProducts');
      if (cartProducts === null || cartProducts.length === 0 ) {
        var prodDtl: ProductDtls = {
          quantity: quantity, 
          servicePeriodCode: servicePeriodCode,
          prodName: ProductName[productId] ?? subscription.Components[0].ProductName,
          currentSubStartDate: currentSubStartDate,
          currentSubExpDate: currentSubExpDate,
          isRenewal: true,
          agreementId: agreementId,
          renewalStartDate: renewalStartDate,
        };
        const prod: {[key: string]: ProductDtls} = { [productId]: prodDtl};
        cartProducts = JSON.stringify([prod]);
        this.sharedDataService.setCartProducts([prod], false);
      } else {
        const productsObj = JSON.parse(cartProducts);
        productsObj.forEach(prod => {
          const itemNumber = Object.keys(prod)[0];
          if(itemNumber === productId) {
            prod[itemNumber].servicePeriodCode = servicePeriodCode,
            prod[itemNumber].quantity = quantity;
            prod[itemNumber].currentSubStartDate = currentSubStartDate;
            prod[itemNumber].currentSubExpDate = currentSubExpDate;
            prod[itemNumber].isRenewal = true;
            prod[itemNumber].agreementId = agreementId;
            prod[itemNumber].renewalStartDate = renewalStartDate;
          }
        });
        this.sharedDataService.setCartProducts(productsObj, false);
      } 
    }
  }

  getOrderReviewQuantityIfExists(quantity: number) : number {
    //incase item is in order review, then use quantity from there
    let reviewItems = sessionStorage.getItem('reviewItems');
    if(reviewItems !== null && reviewItems.length > 0 ) {
      const productsObj = JSON.parse(reviewItems);
      const prod = productsObj.find( (p) => p.itemNumber === this.productNumber);
      if(prod)
        return prod.quantity;
    }
    return quantity;
  }

  getProductName(itemNumber: string) {
    return ProductName[itemNumber];
  }
/**
   * Saves the initial tracking information upon loading the page.
   */
  private saveInitialTrackingInfo(workflow: string) {

    if (this.fromAbandonEmail) {
       console.log('coming from email do not save tracking information');
       return;
    }

    // Prevent running multiple times
    if (this._initialTrackingSaved) {
      console.log('Initial tracking already saved, skipping');
      return;
    }
    let cartProducts = sessionStorage.getItem("cartProducts");

    const arr = JSON.parse(cartProducts ?? "[]");

    if (this.isRenewMissingProdName(workflow, arr)) {
      console.log("Renew workflow but prodName missing — stopping");
      return;
    }
  
    const key = Object.keys(arr[0])[0];
    const { servicePeriodCode } = arr[0][key];

    if (!servicePeriodCode) return;

    const data: { dataKey: DataKeys; dataValue: any }[] = [];
    this.membership = this.userService.isInGroup('member') ? TierName.MEMBER : TierName.NONMBR;
  
    data.push({
      dataKey: DataKeys.WORKFLOW,
      dataValue: workflow
    });
    data.push({
      dataKey: DataKeys.NAME,
      dataValue: this.userService.profile.fullName
    });
    data.push({
        dataKey: DataKeys.MEMBERSHIP,
        dataValue: this.membership
    });
    data.push({
        dataKey: DataKeys.SSO_EMAIL_ADDRESS,
        dataValue: this.userService.profile.email
    });
    if (cartProducts !== null ) {
      const parsed = JSON.parse(cartProducts);
      parsed.forEach(item => {
      const key = Object.keys(item)[0];
      const { quantity, servicePeriodCode, prodName } = item[key];
      // console.log(key, quantity, servicePeriodCode, prodName);
        data.push({
            dataKey: DataKeys.QUANTITY,
            dataValue: quantity
        });
        data.push({
          dataKey: DataKeys.PRODUCT_ITEM_NUMBER,
          dataValue: key
        });
        data.push({
            dataKey: DataKeys.PRODUCT_NAME,
            dataValue: prodName
        });
        data.push({
            dataKey: DataKeys.SERVICE_PERIOD_CODE,
            dataValue: servicePeriodCode
        });
    });
    }
    
    this._initialTrackingSaved = true;

    this.trackingService.upsertFlow({
         customerNbr: this.userService.profile.customerNumber,
         ssoId: this.userService.profile.ssoId,
         data: data,
         events: [{ trackingEvent: AbandonCartEvents.SHOPING_CART_STARTED }],
    });
    

  }
  private isRenewMissingProdName(workflow: string, cart: any[]): boolean {
    if (workflow !== "renew") return false;   // only apply the rule for renew workflow
    if (!cart?.length) return true;           // no cart means prodName missing

    const firstItem = cart[0];
    const key = Object.keys(firstItem)[0];

    return !firstItem[key]?.prodName;         // true → missing prodName
  }
  populateFormFromAbandonCartInfoInError (flow) : boolean{
    const flowResponse: FlowResponse = JSON.parse(flow);
    const flowCustNumber = flowResponse.Data.customerNbr;
    if (flowCustNumber !== this.userService.profile.customerNumber) {
       this.sharedDataService.removeFlowId();
        console.log (`Logged-in user customer number does not match the abandoned-cart customer number.`);
        this.router.navigate(['/']);
        return true;  
    }
    const events = flowResponse.Data?.events || [];
    const hasOrderSubmitted = events.some(
        (e: any) => e.trackingEvent === AbandonCartEvents.ORDER_SUBMITTED
    );
    if (hasOrderSubmitted) {
         this.sharedDataService.removeFlowId();
         console.log (`this flow already been submitted`);
         this.router.navigate(['/']);
         return true;  
    }
    return false;
  }
  populateFormFromAbandonCartInfo(flow) {

      this.sharedDataService.removeFlowId();
      const flowResponse: FlowResponse = JSON.parse(flow);
      const productItem = flowResponse.Data.data.find(d => d.dataKey === DataKeys.PRODUCT_ITEM_NUMBER)?.dataValue;
      const productName = flowResponse.Data.data.find(d => d.dataKey === DataKeys.PRODUCT_NAME)?.dataValue;
      const quantity = flowResponse.Data.data.find(d => d.dataKey === DataKeys.QUANTITY)?.dataValue;
      const servicePeriodCode = flowResponse.Data.data.find(d => d.dataKey === DataKeys.SERVICE_PERIOD_CODE)?.dataValue;
      let address: BillingAddress =
      {
            "CustomerNumber": this.userService.profile.customerNumber,
            "Address" : {
                "AddressCode" : "WBILL",
                "Name" : {
                    "First": flowResponse.Data.data.find(d => d.dataKey === DataKeys.BILLING_FIRST_NAME)?.dataValue ?? '',
                    "Last" : flowResponse.Data.data.find(d => d.dataKey === DataKeys.BILLING_LAST_NAME)?.dataValue ?? '',
                },  
                "Company" : flowResponse.Data.data.find(d => d.dataKey === DataKeys.BILLING_COMPANY_NAME)?.dataValue ?? '',
                "Phone" : flowResponse.Data.data.find(d => d.dataKey === DataKeys.BILLING_PHONE)?.dataValue ?? '',
                "Email" : flowResponse.Data.data.find(d => d.dataKey === DataKeys.BILLING_EMAIL)?.dataValue ?? '',
                "PostalAddress" : {
                  "City" :  flowResponse.Data.data.find(d => d.dataKey === DataKeys.BILLING_ADDRESS_CITY)?.dataValue ?? '',
                  "Line1" :  flowResponse.Data.data.find(d => d.dataKey === DataKeys.BILLING_ADDRESS_LINE1)?.dataValue ?? '',
                  "Line2" :  flowResponse.Data.data.find(d => d.dataKey === DataKeys.BILLING_ADDRESS_LINE2)?.dataValue ?? '', 
                  "PostalCode" :  flowResponse.Data.data.find(d => d.dataKey === DataKeys.BILLING_ZIP_CODE)?.dataValue ?? '',
                  "StateCode" :  flowResponse.Data.data.find(d => d.dataKey === DataKeys.BILLING_ADDRESS_STATE)?.dataValue ?? ''
              }
            }
      };     
      let addrObj: Partial<BillingAddress> = {}; 
      Object.assign(addrObj, address);
      this.sharedDataService.setUserAddress(addrObj);

      let productResult: any[] = [];
      if (productItem && quantity) {
        productResult.push({ [productItem]: Number(quantity) });
        sessionStorage.setItem("products", JSON.stringify(productResult));
      }

      if (!productItem) {
        console.error('productItem is null or undefined');
        return;
      }

      const prods = [
      {
        [productItem]: {
          quantity: Number(quantity),
          servicePeriodCode: servicePeriodCode ?? "",
          prodName: productName ?? ""
        }
      }
      ] as [{ [key: string]: ProductDtls }];
      
      this.sharedDataService.setCartProducts(prods, false);

    }

}
